import { combineReducers } from 'redux';
import bankReducer from './bank/reducers';
import handleReducer from './handle/reducers';
import systemReducer from './system/reducers';

export default combineReducers({
  bank: bankReducer,
  handle: handleReducer,
  system: systemReducer,
});
